import React from 'react';
import clsx from 'clsx';
import CheckIcon from '@mui/icons-material/Check';
import { getRtmEnrollmentStyles } from 'components/rtmEnrollment/rtmEnrollmentStyles';

type ProgressStepperProps = {
  currentStep: number;
  totalSteps: number;
};

export default function ProgressStepper({ currentStep, totalSteps }: ProgressStepperProps) {
  const styles = getRtmEnrollmentStyles();

  return (
    <nav aria-label="Enrollment progress" className={styles.stepper.nav}>
      <ol className={styles.stepper.list}>
        {Array.from({ length: totalSteps }, (_, index) => {
          const stepNumber = index + 1;
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;
          const isFuture = index > currentStep;
          const connectorIsCompleted = index < currentStep;
          const showConnector = index < totalSteps - 1;

          const circleClassName = clsx(
            styles.stepper.circle,
            {
              'bg-populate-green text-white': isCompleted,
              'border border-populate-green text-populate-green bg-populate-green/10': isCurrent,
              'border border-gray-200 text-gray-400 bg-gray-100': isFuture,
            },
          );

          const connectorClassName = clsx(
            styles.stepper.connector,
            {
              'bg-populate-green': connectorIsCompleted,
              'bg-gray-200': !connectorIsCompleted,
            },
          );

          return (
            <li
              key={stepNumber}
              className={clsx(styles.stepper.listItem, {
                [styles.stepper.listItemWithConnector]: showConnector,
              })}
            >
              <div className={circleClassName} aria-current={isCurrent ? 'step' : undefined}>
                {isCompleted ? (
                  <CheckIcon className={styles.stepper.checkIcon} aria-hidden="true" />
                ) : (
                  <span>{stepNumber}</span>
                )}
              </div>
              {showConnector ? <div className={connectorClassName} aria-hidden="true" /> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
